import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink } from '../../components';
import { lazyLoadWithDimensions } from '../../util/contextHelpers';
import { createSlug } from '../../util/urlHelpers';
import css from './SectionCityListings.module.css';
import { formatCityName } from '../../containers/LandingPageCities/LandingPageCities';

const MAX_LISTINGS = 6;

const LocationImage = props => {
  const { alt, ...rest } = props;
  return <img alt={alt} {...rest} />;
};
const LazyImage = lazyLoadWithDimensions(LocationImage);

const SectionCityListings = props => {
  const { intl, rootClassName, className, listings, city, cityLabel, cityConfig, notFoundMsgId = 'SectionCityListings.notFound', seeAllMsgId = 'SectionCityListings.seeAll' } = props;
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); }, []);

  // Use all listings returned from backend, do not filter by city again
  const filtered = listings;
  const showListings = filtered.slice(0, MAX_LISTINGS);
  const hasMore = filtered.length > MAX_LISTINGS;
  const classes = classNames(rootClassName || css.root, className);

  const cityLocalized = intl.formatMessage({ id: `LandingPageCities.${cityLabel ? cityLabel : city.toLowerCase()}` });
  const cityFinal = cityLocalized === `LandingPageCities.${cityLabel ? cityLabel : city.toLowerCase()}` ? city : cityLocalized

  return (
    <div className={classes}>
      {filtered.length === 0 ? (
        <div className={css.notFound}><FormattedMessage id={notFoundMsgId} values={{ city: formatCityName(cityFinal) }} /></div>
      ) : (
        <>
          <div className={classNames(css.containerCard, { [css.bgContainerCard]: showListings.length < 4 })}>
            <div className={css.locations}>
              {showListings.map(l => {
                const slug = createSlug(l.attributes.title);
                const id = l.id.uuid;
                return (
                  <NamedLink name="ListingPage" params={{ id, slug }} className={css.location} key={l.id.uuid}>
                    <div className={css.imageWrapper}>
                      <div className={css.aspectWrapper}>
                        <LazyImage src={l.images[0].attributes.variants['landscape-crop2x'].url} alt={l.attributes.title} className={css.locationImage} />
                      </div>
                    </div>
                    <div className={css.listingTitle}>{l.attributes.title}</div>
                  </NamedLink>
                );
              })}
            </div>
            {hasMore && (
              <NamedLink
                name="SearchPage"
                to={{ search: `?address=${cityConfig.searchParams.address}&bounds=${cityConfig.searchParams.bounds}` }}
                className={classNames(css.oneButton, { [css.oneButtonFEDelay]: mounted })}
              >
                <FormattedMessage id={seeAllMsgId} values={{ city }} />
              </NamedLink>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SectionCityListings;
